import { render, staticRenderFns } from "./DescriptionListItem.vue?vue&type=template&id=db4f95cc"
import script from "./DescriptionListItem.vue?vue&type=script&lang=js"
export * from "./DescriptionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports